// Sprint 2M — Single source of truth for company info.
// All public pages must import from here so that updating the phone number
// or any contact detail in ONE place automatically updates the whole site.

export const COMPANY = {
  legal_name: "EMA Kurer ApS",
  short_name: "EMA Kurer",
  cvr: "46465717",
  // Configurable in one place. Change here → updates Footer + Contact + Navbar + structured data.
  phone: "+45 91 30 93 34",
  phone_e164: "+4591309334", // for tel: links
  email_general: "kontakt@emakurer.dk",
  email_billing: "bogholderi@emakurer.dk",
  email_drift: "drift@emakurer.dk",
  email_jobs: "job@emakurer.dk",
  email_business: "erhverv@emakurer.dk",
  email_subcontractor: "vognmand@emakurer.dk",
  email_orders: "bestilling@emakurer.dk",
  coverage: "Sjælland, Danmark",
  website: "https://emakurer.dk",
  tagline_short: "Lokal kurér og erhvervslevering på Sjælland.",
  tagline_long:
    "Lokal kurér og erhvervslevering på Sjælland — for private, butikker og webshops. Same Day, Next Day og aftenlevering — book enkelt eller få en erhvervsaftale.",
};

export default COMPANY;
